// extracted by mini-css-extract-plugin
export var li = "_vx-2";
export var ol = "_vx-1";
export var ul = "_vx-0";